// Раскомментировать если нужны подсказки по ip
// import {ip} from "./currentIp.json";

import type { BackendNamesKeys } from '../packages/config/BackendNames';
import type { MFNamesKeys } from '../packages/config/MFNames';

enum Browsers {
	googleChromeCanary = 'Google Chrome Canary',
	googleChromeDev = 'Google Chrome Dev',
	googleChromeBeta = 'Google Chrome Beta',
	googleChrome = 'Google Chrome',
	microsoftEdge = 'Microsoft Edge',
	braveBrowser = 'Brave Browser',
	vivaldi = 'Vivaldi',
	chromium = 'Chromium',
	yandex = 'Yandex',
	arc = 'Arc',
}
export type DevConfig<Local extends readonly MFNamesKeys[]> = {
	/**
	 * Будет ли использован ip, для доступа из локально сети локального клиента
	 */
	useExternalIP: boolean;
	/**
	 * Баузер на котором будет поднят локальный клиент
	 */
	browser: Browsers;
	/**
	 * Запуск на определенном ip для того чтобы подняты локальны клиент
	 * был доступен из локальной сети
	 */
	externalIp: string;
	/**
	 * Список мф-ов, которые будут подниматься локально
	 */
	useLocalMfs: Local;
	/**
	 * Список мф-ов, которые будут тянуться с app-review, исключая локальные
	 */
	useTaskNameMfs?: Exclude<MFNamesKeys, Local[number]>[];
	/**
	 * Список локально запущенных серверов
	 */
	useBackendLocal: BackendNamesKeys[];
	/**
	 * Имя mr в gitlab, для того чтобы выкачивать мфы с app-review, а не поднимать локально
	 */
	taskName?: string;
	/**
	 * Запускать ли storybook локально
	 */
	runStorybook: boolean;
};

function createDevConfig<Local extends readonly MFNamesKeys[]>(
	config: Omit<DevConfig<Local>, 'useTaskNameMfs' | 'useLocalMfs'> & {
		useTaskNameMfs: Exclude<MFNamesKeys, Local[number]>[];
		useLocalMfs: Local;
	},
): DevConfig<Local> {
	return config;
}
export const devConfig = createDevConfig({
	useExternalIP: false,
	browser: Browsers.googleChrome,
	externalIp: '',
	useLocalMfs: [],
	useBackendLocal: [],
	useTaskNameMfs: [],
	runStorybook: false,
	taskName: '',
});
